<div class="shipping-policy-container">
  <h1 class="title">Shipping & Delivery Policy</h1>

  <section class="policy-introduction">
    <p>Thank you for shopping at sharaniponguru.me. We are committed to delivering your order accurately, in good condition, and always on time.</p>
    <p>Please read the following shipping and delivery policy carefully.</p>
  </section>

  <section class="book-orders">
    <h2>1. Book Orders (Mindset Shift – Small Changes, Big Impact)</h2>
    <p>Orders for the paperback edition of the Mindset Shift book will be shipped starting from April 16, 2025. All pre-orders placed on or before April 30, 2025 will be dispatched within 7 business days from the start of the shipping window.</p>
  </section>

  <section class="delivery-timeframe">
    <h2>2. Delivery Timeframe</h2>
    <p>All orders are processed and shipped via trusted third-party logistics partners. Delivery usually takes 5 to 10 business days from the dispatch date, depending on the location and courier efficiency.</p>
  </section>

  <section class="shipping-rates">
    <h2>3. Shipping Charges</h2>
    <p>We offer free standard shipping across India for all orders unless stated otherwise during a special promotion.</p>
  </section>

  <section class="tracking">
    <h2>4. Order Tracking</h2>
    <p>Once your order has been dispatched, a tracking link will be shared via WhatsApp or Email (as provided during checkout). Please use this link to monitor the delivery status of your order.</p>
  </section>

  <section class="address-issues">
    <h2>5. Incorrect Address / Failed Delivery Attempts</h2>
    <p>Please ensure your delivery address is complete and accurate. We are not responsible for failed deliveries due to incorrect or incomplete addresses. In case of failed delivery attempts, re-delivery may be initiated at an additional shipping cost.</p>
  </section>

  <section class="international-orders">
    <h2>6. International Shipping</h2>
    <p>Currently, we only ship physical products within India. For international access to bonuses and digital material, users outside India will receive only the digital versions.</p>
  </section>

  <section class="delivery-issues">
    <h2>7. Damaged / Lost in Transit</h2>
    <p>If you receive a damaged book or your order gets lost in transit, please contact us within 7 days of delivery at thesharaniponguru@gmail.com or Call us at +91 7337399049, +91 7892466625. We'll arrange a replacement copy or refund as per our refund policy.</p>
  </section>

  <section class="contact-information">
    <h2>Contact Us</h2>
    <p>If you have any questions about our Shipping & Delivery Policy, please contact us at:</p>
    <p>Email: thesharaniponguru@gmail.com</p>
    <p>Contact us at +91 7337399049, +91 7892466625</p>
  </section>

  <p class="last-updated">Last Updated: June 2023</p>
</div> 